export const versions = {
  date: '2022-03-28T13:34:07.965 UTC+0800',
  sha: '8ec45182b116375a5413b383ca98ea5975880ca1'
};
